import { render, staticRenderFns } from "./ShopCopy.vue?vue&type=template&id=adf37752&"
import script from "./ShopCopy.vue?vue&type=script&lang=js&"
export * from "./ShopCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports